export default "__VITE_ASSET__6VK_FW2q__"